/* eslint-disable @tanstack/query/exhaustive-deps -- queryFn closes over Clerk getToken; cache keyed by userId+sessionId */
import { useAuth } from '@clerk/react';
import { useQuery } from '@tanstack/react-query';
import { fetchPaymentMethods } from '../api/accountApi';
import { useAccountGetToken } from './useAccountApi';

export function usePaymentMethods(enabled = true) {
  const { userId, sessionId } = useAuth();
  const getToken = useAccountGetToken();
  return useQuery({
    queryKey: ['account', 'paymentMethods', userId, sessionId],
    queryFn: () => fetchPaymentMethods(getToken),
    enabled: Boolean(userId) && enabled,
    select: data => data.paymentMethods
  });
}
